import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpXsrfTokenExtractor,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class TokenAuth implements HttpInterceptor {
  cookieService = inject(CookieService);
  constructor(
    readonly router: Router,
    private cookieExtractor: HttpXsrfTokenExtractor,
    public authService: AuthService
    

  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request and add withCredentials: true to ensure cookies are sent
    request = request.clone({ withCredentials: true });

    let token: string = this.authService.getToken();

    // If the token is not formatted correctly, clean it up
    if (token.startsWith("b'")) {
      token = token.slice(2, -1); // Remove the leading "b'" and trailing "'"
    }

    // Add the Authorization header if the token exists
    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      });
    }

    // Return the request with the new headers
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) 
          {
        }
        return event;
      }),
      catchError((error: any) => {
        // console.log(error.error,"error")
        if(error.status === 401 && ((error.error.message == 'Cookie is not present.')||(error.error.message == 'Invalid session ID')))
        {
          localStorage.clear();
          this.cookieService.delete('vicas_token');

          this.router.navigate(['auth/login']);
        }
        return throwError(error);
      })
    );
  }
}
